import { instance } from '../instance';
import { getApiUrl } from '@utils';

export async function deleteCookie() {
  const requestConfig = {
    method: 'delete',
    url: `${getApiUrl()}/auth`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  const res = await instance(requestConfig);
  return res;
}
